import {
  get,
  patch,
  post,
  getArrayBuffer,
  remove
} from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getInvoices({ commit }, { params } = {}) {
    return get(`/ereporter/invoices`, params).then(response => {
      commit('setInvoices', response.data.data);
      commit('setInvoicesFilter', cloneDeep(params));

      return response;
    });
  },

  getInvoiceTypes({ commit }) {
    return get(`/ereporter/invoice/types`).then(response => {
      commit('setInvoiceTypes', response.data.data);

      return response;
    });
  },

  getInvoiceStatuses({ commit }) {
    return get(`/ereporter/invoice/statuses`).then(response => {
      commit('setInvoiceStatuses', response.data.data);

      return response;
    });
  },

  getInvoiceMassStatuses({ commit }) {
    return get(`/ereporter/invoice/list-statuses`).then(response => {
      commit('setInvoiceMassStatuses', response.data.data);

      return response;
    });
  },

  clearInvoicesErrors({ commit }) {
    commit('clearInvoicesErrors');
  },

  updateInvoicesStatuses: ({ commit }, { ids, status }) => {
    return patch(`/ereporter/invoice/update/statuses`, {
      ids,
      status_id: status.id
    }).then(response => {
      const updatedInvoicesIds = response.data.ids || [];
      commit('updateInvoicesStatuses', {
        status,
        ids: updatedInvoicesIds
      });
      commit('setInvoicesErrors', response.data.errors);
      return response;
    });
  },

  getInvoice: ({ commit }, { invoiceId }) => {
    return get(`/ereporter/invoice/${invoiceId}`).then(response => {
      commit('setCurrentInvoice', response.data.data);

      return response;
    });
  },

  updateInvoice: ({ commit }, { invoiceId, invoice }) => {
    return patch(`ereporter/invoice/${invoiceId}`, invoice).then(response => {
      commit('setCurrentInvoice', response.data.data);

      return response;
    });
  },

  removeInvoice(_, { invoiceId }) {
    return remove(`ereporter/invoices/${invoiceId}`).then(response => {
      return response;
    });
  },

  getFilteredInvoiceNumbers(_, params) {
    return get(`/ereporter/invoice-filters/invoice-number`, params);
  },

  getFilteredInvoiceCustomers(_, params) {
    return get(`/ereporter/invoice-filters/customer`, params);
  },

  getPayrolls({ commit }, { params } = {}) {
    return get(`ereporter/payrolls`, params).then(response => {
      commit('setPayrolls', response.data.data);
      commit('setPayrollsFilter', cloneDeep(params));

      return response;
    });
  },

  getPayrollStatuses({ commit }) {
    return get(`/ereporter/payroll/statuses`).then(response => {
      commit('setPayrollStatuses', response.data.data);

      return response;
    });
  },

  getPayrollMassStatuses({ commit }) {
    return get(`/ereporter/payroll/list-statuses`).then(response => {
      commit('setPayrollMassStatuses', response.data.data);

      return response;
    });
  },

  updatePayrollsStatuses: ({ commit }, { ids, status }) => {
    return patch(`/ereporter/payroll/update/statuses`, {
      ids,
      status_id: status.id
    }).then(response => {
      const updatePayrollsIds = response.data.ids || [];

      commit('updatePayrollsStatuses', {
        status,
        ids: updatePayrollsIds
      });

      return response;
    });
  },

  getPayroll({ commit }, { payrollId }) {
    return get(`ereporter/payroll/${payrollId}`).then(response => {
      commit('setCurrentPayroll', response.data.data);

      return response;
    });
  },

  updatePayroll: ({ commit }, { payrollId, payroll }) => {
    return patch(`ereporter/payroll/${payrollId}`, payroll).then(response => {
      commit('setCurrentPayroll', response.data.data);

      return response;
    });
  },

  getFilteredPayrollEmployee(_, params) {
    return get(`/ereporter/payroll-filters/employee`, params);
  },

  getInvoicePdf(_, { id, params }) {
    return getArrayBuffer(`ereporter/invoice/print/${id}`, params);
  },

  getInvoicesPdf(_, params) {
    return getArrayBuffer(`ereporter/invoices/print-list`, params);
  },

  getInvoicesExportXls(_, params) {
    return getArrayBuffer(`ereporter/invoices-export`, params);
  },

  getExpenses({ commit }, { params } = {}) {
    return get(`ereporter/expenses`, params).then(response => {
      commit('setExpenses', response.data.data);
      commit('setExpensesFilter', cloneDeep(params));

      return response;
    });
  },

  getExpensesExportFile(_, { params } = {}) {
    return getArrayBuffer(`ereporter/expenses-export`, params);
  },

  updateExpensesStatuses: ({ commit }, { ids, status }) => {
    return patch(`/ereporter/expense/update/statuses`, {
      ids,
      status_id: status.id
    }).then(response => {
      const updateExpensesIds = response.data.ids || [];

      commit('updateExpensesStatuses', {
        status,
        ids: updateExpensesIds
      });

      return response;
    });
  },

  getAmountReport({ commit }, { amountId }) {
    return get(`ereporter/expense-report/${amountId}`).then(response => {
      commit('setCurrentAmount', response.data.data);

      return response;
    });
  },

  createAmountReport: ({ commit }, { amount }) => {
    return post(`ereporter/expense-report`, amount).then(response => {
      commit('setCurrentAmount', response.data.data);

      return response;
    });
  },

  updateAmountReport: ({ commit }, { amount }) => {
    return patch(`ereporter/expense-report/${amount.id}`, amount).then(
      response => {
        commit('setCurrentAmount', response.data.data);

        return response;
      }
    );
  },

  getExpense({ commit }, { expenseId }) {
    return get(`ereporter/expense/${expenseId}`).then(response => {
      commit('setCurrentExpense', response.data.data);

      return response;
    });
  },

  removeAmount({ commit }, id) {
    return remove(`ereporter/expense-report/${id}`).then(response => {
      return response;
    });
  },

  sendInvoicesViaEmails(_, params) {
    return getArrayBuffer(`ereporter/invoices/send/via-emails`, params);
  },

  getCInvoices({ commit }, { id, params } = {}) {
    return get(`/persons/${id}/invoices`, params).then(response => {
      return response;
    });
  },
  getBInvoices({ commit }, { id, params } = {}) {
    return get(`/companies/${id}/invoices`, params).then(response => {
      return response;
    });
  },
  createCInvoice: ({ commit }, { id, invoice }) => {
    return post(`/persons/${id}/invoices`, invoice).then(response => {
      return response;
    });
  },
  createBInvoice: ({ commit }, { id, invoice }) => {
    return post(`/companies/${id}/invoices`, invoice).then(response => {
      return response;
    });
  },

  getAccountParams: ({ commit }) => {
    return get(`/ereporter/invoices/accounts`).then(response => {
      commit('setAccountParams', response.data.data);

      return response;
    });
  },

  getCustomerAddresses: ({ commit }, { params }) => {
    return get(`/addresses`, params).then(response => {
      return response;
    });
  }
};
